'use client';
import { type AutocompleteRenderGroupParams, Divider, Typography } from '@castlery/fortress';
import React from 'react';
import type { CouponItemType as CouponItemTypeV1 } from './helper';
import type { CouponItemType as CouponItemTypeV2 } from './helperV2';

// import { useAppSelector } from '@castlery/shared-redux-store';
// import { selectYotpoCreditsPoints } from '@castlery/modules-order-domain';

export const groupBy = (options: CouponItemTypeV1 | CouponItemTypeV2) => options.couponType;

export const renderGroup = (params: AutocompleteRenderGroupParams, points: number) => {
  // const creditsPoints = useAppSelector(selectYotpoCreditsPoints);
  return (
    <React.Fragment>
      {params.group === 'credits-notice' ? (
        <>
          <Typography level="caption1" sx={{ paddingX: 2, paddingY: 1, textAlign: 'center' }}>
            You have <Typography color="primary">{points} credits</Typography> available.
          </Typography>
        </>
      ) : (
        <>
          {params.group === 'credits' && <Divider />}
          {params.children}
        </>
      )}
    </React.Fragment>
  );
};
